export const AppConfig = {
    backendApi: (process.env.REACT_APP_BACKEND_API_URL as unknown) as string,
    backendAuth: (process.env.REACT_APP_BACKEND_AUTH_URL as unknown) as string,
    authUrl: (process.env.REACT_APP_AUTH_URL as unknown) as string,
    fidUrl: (process.env.REACT_APP_FID_URL as unknown) as string,
}
